// Timezone options using IANA timezone strings
export const TIMEZONE_OPTIONS = [
  { value: 'UTC', label: 'UTC (+00:00)' },
  { value: 'America/New_York', label: 'New York (Eastern Time)' },
  { value: 'America/Chicago', label: 'Chicago (Central Time)' },
  { value: 'America/Denver', label: 'Denver (Mountain Time)' },
  { value: 'America/Los_Angeles', label: 'Los Angeles (Pacific Time)' },
  { value: 'America/Phoenix', label: 'Phoenix (Mountain Time - No DST)' },
  { value: 'America/Anchorage', label: 'Anchorage (Alaska Time)' },
  { value: 'Pacific/Honolulu', label: 'Honolulu (Hawaii Time)' },
  { value: 'Europe/London', label: 'London (GMT/BST)' },
  { value: 'Europe/Paris', label: 'Paris (Central European Time)' },
  { value: 'Europe/Berlin', label: 'Berlin (Central European Time)' },
  { value: 'Asia/Dubai', label: 'Dubai (Gulf Time)' },
  { value: 'Asia/Shanghai', label: 'Shanghai (China Time)' },
  { value: 'Asia/Tokyo', label: 'Tokyo (Japan Time)' },
  { value: 'Asia/Singapore', label: 'Singapore Time' },
  { value: 'Australia/Sydney', label: 'Sydney (Eastern Australia Time)' },
  { value: 'Pacific/Auckland', label: 'Auckland (New Zealand Time)' }
];